/* eslint-disable react-hooks/exhaustive-deps */
import {
  getAllSalesContractApi,
  getAllSalesInvoiceApi,
} from "../../services/_sales";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import Spinner from "../../theme/Spinner";
import { getAllChaApi } from "../../services/_cha";
import { useEffect, useRef, useState } from "react";
import Pagination from "../../components/Pagination";
import { CURRENCY } from "../../components/Constants";
import { chaWisePaymentReportApi } from "../../services/_report";
import {
  formatAmount,
  formatDate,
  formatString,
} from "../../components/Helper";
import { PaymentStatus, TransactionTypes } from "../../components/Enums";

interface CustomCSVLink extends HTMLAnchorElement {
  link: HTMLAnchorElement;
}

const ChaWisePaymentReport = () => {
  const [chaPaymentRecord, setChaPaymentRecord] = useState<any[]>([]);
  const [chaNames, setChaName] = useState<any[]>([]);
  const [salesNames, setSalesNames] = useState<any[]>([]);
  const [saleOrderName, getSaleOrderName] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState(null);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [filterCha, setFilterCha] = useState<string>("");
  const [filterSale, setFilterSale] = useState<string>("");
  const [filterSaleOrder, setFilterSaleOrder] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const csvLinkRef = useRef<CustomCSVLink>(null);
  const [exportData, setExportData] = useState([]);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const chaNameList = async () => {
    try {
      const result: any = await getAllChaApi();
      setChaName(result?.data);
    } catch (error) {
      console.error("Error Fetching CHA List", error);
    }
  };

  const getSalesList = async (query?: string) => {
    try {
      const result: any = await getAllSalesContractApi(query && query);
      setSalesNames(result?.data);
    } catch (err) {
      console.error("Error Fetching Sales Data", err);
    }
  };

  const getSaleOrderList = async (query?: string) => {
    try {
      const result: any = await getAllSalesInvoiceApi(query && query);
      getSaleOrderName(result?.data);
    } catch (error) {
      console.error("Error fetching commercial invoice list", error);
    }
  };

  const getChaPaymentReportList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string,
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (filterCha) {
        query += `&cha_id=${filterCha}`;
      }
      if (filterSale) {
        const contract = salesNames.find((s: any) => s.id === filterSale);
        if (contract) {
          query += `&sales_contract_no=${encodeURIComponent(contract.contract_no)}`;
        }
      }
      if (filterSaleOrder) {
        query += `&sales_invoice_id=${filterSaleOrder}`;
      }
      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }

    const result: any = await chaWisePaymentReportApi(query);
    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setChaPaymentRecord(result?.data.records);
      setTotalPages(totalPagesCount);
      setTotalRecords(result.data.total_records);
      setTotalCreditAmount(result?.data?.total_credit || 0);
      setTotalDebitAmount(result?.data?.total_debit || 0);
      setTotalAmount(result?.data?.total_amount || 0);
    }
    setLoading(false);
  };

  const filterList = async () => {
    setApplyFilter(true);
    getChaPaymentReportList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterCha("");
    setFilterSale("");
    setFilterSaleOrder("");
    setDateRange(null);
    getSalesList();
    getSaleOrderList();
    getChaPaymentReportList(page, perPage);
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const getFileName = () => {
    const filerName = "cha-wise-payment-report";
    return `${filerName}-${moment().format("MM-DD-YYYY-HH-mm-ss")}.csv`;
  };

  const exportCHAPaymentRecords = async () => {
    setExportData([]);
    let csvHeader: any;
    let csvData: any;
    let csvFooter: any;

    let query = `export=true`;
    if (filterCha) {
      query += `&cha_id=${filterCha}`;
    }
    if (filterSale) {
      const contract = salesNames.find((s: any) => s.id === filterSale);
      if (contract) {
        query += `&sales_contract_no=${encodeURIComponent(contract.contract_no)}`;
      }
    }
    if (filterSaleOrder) {
      query += `&sales_invoice_id=${filterSaleOrder}`;
    }
    if (dateRange) {
      query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
      query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
    }
    if (sortKey && sortType) {
      query += `&sort_key=${sortKey}&sort_type=${sortType}`;
    }

    const result: any = await chaWisePaymentReportApi(query);
    if (result.isSuccess) {
      if (result.data.records) {
        csvHeader = [
          "Sr No.",
          "CHA",
          "Sales Contract No",
          "Commercial Invoice No",
          "Amount",
          "Transaction Type",
          "Payment Method",
          "Transaction No",
          "Payment Status",
          "Remark",
          "Transaction Date",
        ];
        csvData = result.data.records.map((item: any, index: number) => [
          (index + 1).toString(),
          item?.cha?.name || "",
          Array.from(
            new Set(
              item?.sales_invoice?.sales_invoice_products?.map(
                (p: any) => p?.sales_contract?.contract_no,
              ),
            ),
          ).join(", ") || "",
          item?.sales_invoice?.invoice_no || "",
          `${CURRENCY.INR.SYMBOL}${formatAmount(item.amount)}`,
          item?.transaction_type || "",
          item?.payment_method.replace("_", " ") || "",
          item?.transaction_no || "",
          formatString(item?.payment_status) || "",
          item?.remark || "",
          formatDate(item.transaction_date),
        ]);
        csvFooter = [
          [
            "",
            "",
            "",
            "Total Credit :",
            `${CURRENCY.INR.SYMBOL}${formatAmount(totalCreditAmount)}`,
            "",
            "",
            "",
            "",
            "",
            "",
          ],
          [
            "",
            "",
            "",
            "Total Debit :",
            `${CURRENCY.INR.SYMBOL}${formatAmount(totalDebitAmount)}`,
            "",
            "",
            "",
            "",
            "",
            "",
          ],
          [
            "",
            "",
            "",
            totalAmount > 0 ? "Profit :" : "Loss :",
            `${CURRENCY.INR.SYMBOL}${formatAmount(totalAmount)}`,
            "",
            "",
            "",
            "",
            "",
            "",
          ],
        ];

        const exportData: any = [csvHeader, ...csvData, ...csvFooter];
        setExportData(exportData);

        if (csvLinkRef.current?.link) {
          setTimeout(() => {
            csvLinkRef.current!.link.click();
          }, 0);
        }
      }
    }
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getChaPaymentReportList(page, perPage, true, key, type);
  };

  const filterSuggestion = ({ target: { name, value } }: any) => {
    const query = value && `${name}=${value}`;
    if (name === "cha_id") {
      getSalesList(query);
      getSaleOrderList(query);
    }
    if (name === "sales_contract_id") {
      const queryString = filterCha ? `${query}&&cha_id=${filterCha}` : query;
      getSaleOrderList(queryString);
    }
  };

  useEffect(() => {
    chaNameList();
    getSalesList();
    getSaleOrderList();
  }, []);

  useEffect(() => {
    if (page && perPage) {
      getChaPaymentReportList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>CHA Wise Payment Report</h5>
          </div>
          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            <Link
              to={"#"}
              className="btn btn-primary waves-effect waves-light"
              type="button"
              onClick={() => {
                exportCHAPaymentRecords();
              }}
            >
              <span>
                <i className="ti ti-download me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Download Excel</span>
              </span>
            </Link>
            <CSVLink
              data={exportData}
              filename={getFileName()}
              className="d-none"
              ref={csvLinkRef as any}
            >
              <span>
                <i className="ti ti-download me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Download Excel</span>
              </span>
            </CSVLink>
          </div>
        </div>

        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="date"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Transaction Date:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="cha_id"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        CHA:
                      </label>
                      <select
                        className="form-select"
                        name="cha_id"
                        id="cha_id"
                        value={filterCha}
                        onChange={(e) => {
                          setFilterCha(e.target.value);
                          filterSuggestion(e);
                        }}
                      >
                        <option value="">Select CHA</option>
                        {chaNames.map((cha) => (
                          <option value={cha.id} key={cha.id}>
                            {cha?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="sales_contract_id"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Sales Contract No:
                      </label>
                      <select
                        className="form-select"
                        name="sales_contract_id"
                        id="sales_contract_id"
                        value={filterSale}
                        onChange={(e) => {
                          setFilterSale(e.target.value);
                          filterSuggestion(e);
                        }}
                      >
                        <option value="">Select Sales Contract No</option>
                        {salesNames.map((sale) => (
                          <option value={sale.id} key={sale.id}>
                            {sale.contract_no}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        htmlFor="sales_invoice_id"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Commercial Invoice No:
                      </label>
                      <select
                        className="form-select"
                        name="sales_invoice_id"
                        id="sales_invoice_id"
                        value={filterSaleOrder}
                        onChange={(e) => {
                          setFilterSaleOrder(e.target.value);
                        }}
                      >
                        <option value="">Select Commercial Invoice No</option>
                        {saleOrderName.map((order) => (
                          <option value={order.id} key={order.id}>
                            {order.invoice_no}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}

          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th className="cursor-pointer" onClick={() => sortTable("cha")}>
                  CHA
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("contract_no")}
                >
                  Sales Contract No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("invoice_no")}
                >
                  Commercial Invoice No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("amount")}
                >
                  Amount
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("transaction_type")}
                >
                  Transaction Type
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("payment_method")}
                >
                  Payment Method
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("transaction_no")}
                >
                  Transaction No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("payment_status")}
                >
                  Payment Status
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("remark")}
                >
                  Remark
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("transaction_date")}
                >
                  Transaction Date
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {chaPaymentRecord.length > 0 ? (
                <>
                  {chaPaymentRecord.map((item: any, i: number) => {
                    let transactionTypeClass = "";
                    if (item.transaction_type === TransactionTypes.CREDIT) {
                      transactionTypeClass = `bg-label-success`;
                    } else {
                      transactionTypeClass = `bg-label-danger`;
                    }
                    let statusClass = "";
                    if (item.payment_status === PaymentStatus.PENDING) {
                      statusClass = `bg-label-warning`;
                    } else if (
                      item.payment_status === PaymentStatus.COMPLETED
                    ) {
                      statusClass = `bg-label-success`;
                    } else if (item.payment_status === PaymentStatus.ADVANCE) {
                      statusClass = `bg-label-info`;
                    } else {
                      statusClass = `bg-label-secondary`;
                    }
                    return (
                      <tr key={item.id}>
                        <td>{i + 1}</td>
                        <td>{item?.cha?.name || ""}</td>
                        <td>
                          {" "}
                          {Array.from(
                            new Set(
                              item?.sales_invoice?.sales_invoice_products?.map(
                                (p: any) => p?.sales_contract?.contract_no,
                              ),
                            ),
                          ).join(", ") || ""}
                        </td>
                        <td>{item?.sales_invoice?.invoice_no || ""}</td>
                        <td>
                          {CURRENCY.INR.SYMBOL}
                          {formatAmount(item.amount)}
                        </td>
                        <td>
                          <span
                            className={`badge ${transactionTypeClass} me-1`}
                          >
                            {item.transaction_type}
                          </span>
                        </td>
                        <td>{item?.payment_method.replace("_", " ") || ""}</td>
                        <td>{item?.transaction_no || ""}</td>
                        <td>
                          <td>
                            <span className={`badge ${statusClass} me-1`}>
                              {formatString(item.payment_status)}
                            </span>
                          </td>
                        </td>
                        <td>{item?.remark || ""}</td>
                        <td>{formatDate(item.transaction_date)}</td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <tr>
                  <td colSpan={11} className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="row mt-5 mx-0 align-items-center">
          <div className="col-sm-4 text-sm-center">
            <div>
              Total Credit:{" "}
              <span
                className="fw-bold"
                style={{ fontWeight: 500, color: "#444050" }}
              >
                {CURRENCY.INR.SYMBOL}
                {formatAmount(totalCreditAmount)}
              </span>
            </div>
          </div>
          <div className="col-sm-4 text-sm-center">
            <div>
              Total Debit:{" "}
              <span
                className="fw-bold"
                style={{ fontWeight: 500, color: "#444050" }}
              >
                {CURRENCY.INR.SYMBOL}
                {formatAmount(totalDebitAmount)}
              </span>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="d-flex justify-content-sm-center">
              <p
                className="p-0 m-0"
                style={{
                  color: totalAmount > 0 ? "green" : "red",
                }}
              >
                {totalAmount > 0 ? "Profit:" : "Loss:"}
              </p>
              &nbsp;
              <span
                className="fw-bold"
                style={{ fontWeight: 500, color: "#444050" }}
              >
                {CURRENCY.INR.SYMBOL}
                {formatAmount(totalAmount)}
              </span>
            </div>
          </div>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={chaPaymentRecord}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};
export default ChaWisePaymentReport;
